import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import { PermissionGate } from '@saas/ui';
import { CONTRACT_ADMIN_ROLES } from './nav.js';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

function admin(load: () => Promise<PageModule>, anyOf: string[]): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    const Page = m.default;
    const Guarded = () => (
      <PermissionGate anyOf={anyOf} roles={CONTRACT_ADMIN_ROLES}>
        <Page />
      </PermissionGate>
    );
    return { Component: Guarded };
  };
}

export const contractRoutes: RouteObject[] = [
  { path: '/contract/esign', lazy: page(() => import('./pages/NativeEsignPage.js')) },
  { path: '/contract/esign/:id', lazy: page(() => import('./pages/NativeEsignPage.js')) },
  { path: '/contract/esign/settings', lazy: async () => ({ Component: (await import('./pages/NativeEsignPage.js')).NativeSettingsPage }) },
  { path: '/contract', lazy: page(() => import('./pages/ContractListPage.js')) },
  { path: '/contract/new', lazy: page(() => import('./pages/ContractFormPage.js')) },
  { path: '/contract/contracts/:id', lazy: page(() => import('./pages/ContractDetailPage.js')) },
  { path: '/contract/contracts/:id/edit', lazy: page(() => import('./pages/ContractFormPage.js')) },
  { path: '/contract/alerts', lazy: page(() => import('./pages/ContractAlertsPage.js')) },
  { path: '/contract/search', lazy: page(() => import('./pages/ContractSearchPage.js')) },
  { path: '/contract/admin/retention', lazy: admin(() => import('./pages/ContractRetentionPage.js'), ['contract.retention.manage']) },
  // gap-ops: 期限アラートの休日の扱い・電子契約サービスとの接続と受けた通知
  { path: '/contract/admin/settings', lazy: admin(() => import('./pages/ContractSettingsPage.js'), ['contract.settings.manage']) },
];
export const contractPublicRoutes: RouteObject[] = [
  { path: '/sign/:publicId', lazy: page(() => import('./pages/NativeSignPage.js')) },
];
